import { render, staticRenderFns } from "./EnergienaheDienstleistungenIcon.vue?vue&type=template&id=065a4756&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports